module.exports = __webpack_public_path__ + "static/img/2.587c3f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/2.png
// module id = qSSK
// module chunks = 0